import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { Button1Component } from '../button1/button1.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import { BusyService } from '../../_services/busy.service';
import { GalleriaModule } from 'primeng/galleria';
import { DialogModule } from 'primeng/dialog';
import { CommanService } from '../../_services/comman.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-detail',
  standalone: true,
  imports: [
    CommonModule,

    Button1Component,
    GalleriaModule,
    DialogModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.scss',
})
export class DetailComponent implements OnInit, OnDestroy, AfterViewInit {
  detailPageData: any = {};

  currColumns: any[] = [];
  sectionsItems: any[] = [
    {
      section_id: 'section1',
      section_name: 'Product description',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'gbrn',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'cbrnGapd',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'ipdRegistationNumber',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'jarvisRegistationNumberPatent',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'activeIngredientFrequentlyUse',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'activeIngredientNative',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'tradeProprietaryNames',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'alternateBrandName',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'inactiveBrandName',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'iupac',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'casRn',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'chemicalClass',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'indication',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'racIracHracFrac',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'modeOfActionMoa',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'productSummary',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'description',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        // {
        //   field_name: 'chemicalStructure',
        //   table_name: 'basic_product_details_MONGO',
        //   isHide_field: false,
        // },
        {
          field_name: 'iupac',
          table_name: 'basic_product_details_MONGO',
          isHide_field: false,
        },
        {
          field_name: 'casRn',
          table_name: 'basic_product_details_MONGO',
          isHide_field: false,
        },
        {
          field_name: 'chemicalClass',
          table_name: 'basic_product_details_MONGO',
          isHide_field: false,
        },
        {
          field_name: 'mechanismOfActionMoa',
          table_name: 'basic_product_details_MONGO',
          isHide_field: false,
        },
        {
          field_name: 'indication',
          table_name: 'basic_product_details_MONGO',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section2',
      section_name: 'Product Registration',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'applicantRegistrationHolder',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        // {
        //   field_name: 'company',
        //   table_name: 'gapd_mongos',
        //   isHide_field: false,
        // },
        {
          field_name: 'address',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'cityStateZip',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'poBox',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'registrationNumber',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'acceptedDate',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'expiryDate',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'firstRegisteredDate',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'updationDate',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'currentStatus',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'manufactures',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'technicalManufactures',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'countryOfTechnicalManufactures',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'formulationManufactures',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'countryOfFormulationManufactures',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'technicalAsWellAsFormulationManufactures',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'importerOfTechnicalProduct',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'importerOfFormulatedProduct',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'partners',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'consultancyFirms',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'registeredProductUnderSectionRelatedToParticularCountry',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'transferHistory',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'divisionName',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'restrictedUse',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section3',
      section_name: 'Product Market',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'country',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'statesOrProvinces',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section4',
      section_name: 'Product Type',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'typeOfProduct',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'combinationType',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section5',
      section_name: 'Product Concentration',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'ratioStrength',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'concentration',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'volume',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'class',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'formulation',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section6',
      section_name: 'Product Application',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'crop',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'pestPathogenSpectrum',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'site',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'formOfAction',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'benefits',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dosage',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'use',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'rateOfUse',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'useRestriction',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'precautions',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section7',
      section_name: 'Product Toxicity',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'toxicity',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'toxicologicalClassification',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section8',
      section_name: 'Product Packing',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'packingDescription',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'packSize',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'qualityPerCartonAndPerPallet',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section9',
      section_name: 'Product Pricing',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'productWholesalePrice',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'productRetailPriceMrp',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'availability',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section10',
      section_name: 'Product Documents',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'documents',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'factsheet',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'monograph',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'productArchive',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'regulatoryDocuments',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'mutipleDocuments',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section11',
      section_name: 'References',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'references',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'remarks',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section12',
      section_name: 'Miscellaneous',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'agentNameDistributorsName',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'agentNameDistributorsAddress',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'agentCityZip',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'agentPoBox',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'signalWord',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'specialLocalNeedsNumber',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'miscellaneous',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'url1',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'url2',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'notes',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'comments',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
    {
      section_id: 'section13',
      section_name: 'Dummy',
      isSelected: false,
      isHide: false,
      fields: [
        {
          field_name: 'dummy1',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy2',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy3',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy4',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy5',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy6',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy7',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy8',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy9',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
        {
          field_name: 'dummy10',
          table_name: 'gapd_mongos',
          isHide_field: false,
        },
      ],
    },
  ];

  expenedField: string = '';

  constructor(
    private _commanService: CommanService,
    private _messageService: MessageService,
    private _router: Router,
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.detailPageData = history.state;

    // Get columns
    this._commanService.getColumns().subscribe((res) => {
      this.currColumns = res.filter((res) => res.field !== 'S_NO');
    });

    this.sectionsItems.forEach((elem: any, index: number) => {
      if (index === 0) {
        elem.isSelected = true;
      }
    });
  }

  scrollContainer: HTMLElement | null = null;

  ngAfterViewInit(): void {
    window.scrollTo(0, 0);

    // this.scrollContainer = document.querySelector(
    //   '.main_dataContainer_leftBox'
    // );

    // if (this.scrollContainer) {
    //   this.scrollContainer.addEventListener(
    //     'scroll',
    //     this.onContainerScroll.bind(this)
    //   );
    // }

    // Check if detailPageData not provided then return to search screan
    this.hideFieldsAndSections();

    if (sessionStorage.getItem('isRefreshed')) {
      sessionStorage.removeItem('isRefreshed');
      this.goBackToSearch();
    }

    // Listen to the beforeunload event
    window.addEventListener('beforeunload', this.handleRefresh);

    this._cdr.detectChanges();
  }
  display: boolean = false;
  images: any[] = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  showImage(imageUrl: string) {
    this.images = [
      {
        itemImageSrc: imageUrl,
        alt: 'Image',
        title: 'Preview',
      },
    ];
    this.display = true;
  }

  getFieldDisplayName(fieldName: string) {
    const found = this.currColumns.find(
      (elem: any) => elem.field === fieldName
    );
    return found ? found.header : fieldName;
  }

  currReadMoreData: string[] = [];
  isShowReadMoreDetailDialog: boolean = false;

  showAllGapdTableData(item: any, fieldName: string) {
    if (item && item[fieldName]) {
      this.currReadMoreData = [item[fieldName]];
    } else {
      this.currReadMoreData = [];
    }

    this.isShowReadMoreDetailDialog = true;
  }

  copyToClipboard(field: any): void {
    if (field) {
      this.copyOnClipboard(this.detailPageData[field.field_name]);
    }
    if (field) {
      if (this.detailPageData?.gbrn_products?.length > 0) {
        this.currReadMoreData = this.detailPageData.gbrn_products
          .map((prod: any) => prod[field.field_name])
          .filter((val: string | undefined) => val);

        const result = this.currReadMoreData.join('\n');
        this.copyOnClipboard(result);
      } else {
        this.copyOnClipboard('');
      }
    }
  }

  copyOnClipboard(item: any) {
    navigator.clipboard
      .writeText(item)
      .then(() => {
        this._messageService.add({
          severity: 'success',
          summary: 'Copied',
          detail: 'Copy To Clipboard',
        });
      })
      .catch((err) => {
        this._messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'There was an error copying the text.',
        });
      });
  }

  // onContainerScroll() {
  //   if (!this.scrollContainer) return;

  //   for (const section of this.sectionsItems) {
  //     const el = document.getElementById(section.section_id);
  //     if (el) {
  //       const containerRect = this.scrollContainer.getBoundingClientRect();
  //       const sectionRect = el.getBoundingClientRect();

  //       const top = sectionRect.top - containerRect.top;

  //       if (top <= 10 && top + el.offsetHeight >= 10) {
  //         if (!section.isSelected) {
  //           this.sectionsItems.forEach(
  //             (s) => (s.isSelected = s.section_id === section.section_id)
  //           );
  //         }
  //         break;
  //       }
  //     }
  //   }
  // }

  // Old code for scroll to section
  openSection(sectionId: string) {
    const scrollContainer = document.querySelector(
      '.main_dataContainer_leftBox'
    );
    const element = document.getElementById(sectionId);

    if (element && scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const yOffset = -10;

      const scrollTop =
        scrollContainer.scrollTop +
        (elementRect.top - containerRect.top + yOffset);

      scrollContainer.scrollTo({ top: scrollTop, behavior: 'smooth' });

      this.sectionsItems.forEach((section) => {
        section.isSelected = section.section_id === sectionId;
      });
    }
  }

  // @HostListener('window:scroll', [])
  // onScroll() {
  //   for (const section of this.sectionsItems) {
  //     const el = document.getElementById(section.section_id);
  //     if (el) {
  //       const rect = el.getBoundingClientRect();
  //       if (rect.top <= 10 && rect.bottom >= 10) {
  //         this.sectionsItems.forEach(
  //           (s) => (s.isSelected = s.section_id === section.section_id)
  //         );
  //         break;
  //       }
  //     }
  //   }
  // }

  // New code for scroll to section
  // openSection(sectionId: string) {

  // this.sectionsItems.forEach((section: any) => {
  //   section.isSelected = section.section_id === sectionId;
  // });

  // }

  hideFieldsAndSections() {
    // 1) If no detail data → redirect + error
    if (
      Object.keys(this.detailPageData).length === 1 &&
      Object.keys(this.detailPageData)[0] === 'navigationId'
    ) {
      this._router.navigateByUrl('/search');
      this._messageService.add({
        severity: 'error',
        summary: 'No data',
        detail: 'Detail page data not available',
      });
      return;
    }

    // 2) Process each field
    this.sectionsItems.forEach((section: any) => {
      section.fields.forEach((field: any) => {
        if (!field) return;

        const fieldName = field.field_name;

        // --- A) Check value in main object ---
        const mainValue = this.detailPageData[fieldName];
        let hasMainValue = false;

        if (mainValue) {
          if (Array.isArray(mainValue)) {
            hasMainValue = mainValue.some((v: any) => v && v !== '');
          } else {
            hasMainValue = mainValue !== '';
          }
        }

        // --- B) Check value inside gbrn_products array ---
        let hasProductValue = false;
        if (this.detailPageData.gbrn_products?.length) {
          hasProductValue = this.detailPageData.gbrn_products.some(
            (obj: any) => obj[fieldName] && obj[fieldName] !== ''
          );
        }

        // --- C) Final visibility logic ---
        const finalHasData = hasMainValue || hasProductValue;

        field.isHide_field = !(finalHasData && this.isShowField(fieldName));
      });
    });

    // 3) Hide whole section if ALL fields inside are hidden
    this.sectionsItems.forEach((section: any) => {
      section.isHide = section.fields.every(
        (field: any) => field.isHide_field === true
      );
    });
  }

  handleRefresh() {
    sessionStorage.setItem('isRefreshed', 'true');
  }

  goBackToSearch() {
    this._router.navigate(['/search']).then(() => {
      window.scrollTo(0, 0);
    });
  }

  getDocumentList(fieldName: string): string[] {
    const fieldValue = this.detailPageData[fieldName];

    if (!fieldValue) return [];

    let documents: string[] = [];

    if (fieldValue.includes('\n')) {
      documents = fieldValue.split('\n');
    } else if (fieldValue.includes(';')) {
      documents = fieldValue.split(';');
    } else {
      documents = [fieldValue];
    }

    // Fix invalid extension
    documents = this.fixInvalidExtensions(documents);

    // Fix dynamic label prefixes and keep only URLs
    if (fieldName === 'regulatoryDocuments') {
      documents = this.fixUrlKeyIssue(documents);
    }

    // console.log('Other Document', documents);
    return documents.map((f: string) => f.trim()).filter((f: string) => f);
  }

  fixInvalidExtensions(values: string[]): string[] {
    return values.map((value) =>
      value.endsWith('.HTML') ? value.slice(0, -5) + '.html' : value
    );
  }

  fixUrlKeyIssue(value: string[]): string[] {
    return value
      .filter((line) => line.trim() !== '')
      .map((line) => {
        const match = line.match(/https?:\/\/\S+/);
        return match ? match[0] : null;
      })
      .filter(Boolean) as string[];
  }

  ngOnDestroy(): void {
    this._commanService.removeLastBreadCrumbValue();

    // if (this.scrollContainer) {
    //   this.scrollContainer.removeEventListener(
    //     'scroll',
    //     this.onContainerScroll
    //   );
    // }
  }

  isShowField(fieldName: string) {
    let matchedFieldObj = this.currColumns.find((columnObj: any) => {
      return columnObj.field === fieldName;
    });

    if (matchedFieldObj) {
      return true;
    } else {
      return false;
    }
  }

  goBackToGapd(): void {
    this._router.navigate(['/platform/gapd-database']);
  }
}
